import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select";

export const GOOGLE_FONTS = [
  'Inter', 'Roboto', 'Open Sans', 'Lato', 'Montserrat', 'Oswald', 
  'Source Sans Pro', 'Raleway', 'PT Sans', 'Merriweather', 'Noto Sans', 
  'Nunito', 'Playfair Display', 'Ubuntu', 'Rubik', 'Lora', 'Work Sans', 
  'Fira Sans', 'Quicksand', 'Barlow', 'Inconsolata', 'Josefin Sans',
  'Libre Baskerville', 'DM Sans', 'Poppins', 'Outfit', 'Space Grotesk'
].sort();

export function FontPicker({ value, onChange }: { value?: string; onChange: (val: string) => void }) {
  // We apply the fontFamily style to each item inline so the dropdown shows a preview
  // Since we aren't preloading these fonts, they will fallback to sans-serif unless the user
  // happens to have them installed locally. If they select one, it will load in the iframe.
  return (
    <Select value={value} onValueChange={(val) => { if (val) onChange(val as string); }}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select a font" />
      </SelectTrigger>
      <SelectContent className="max-h-[300px]">
        {GOOGLE_FONTS.map((font) => (
          <SelectItem key={font} value={font}>
            {font}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
